import {Ace} from "ace-code";
import {CommandManager} from "ace-layout";

export let menuDefs = {
    "AWS Cloud9": "50,,,,",
    "File": "100,,,,",
    "Edit": "200,,,,",
    "Find": "300,,,,",
    "View": "400,,,,",
    "Go": "500,,,,",
    "Tools": "700,,,,",
    "Window": "800,,,,",
    "File/~1000000": "1000000,,,,",
    "View/~9999": "9999,,,,",
    "Window/Presets": "10200,,false,, ",
    "Window/Presets/Full IDE": "100,,false,, ",
    "Window/Presets/Minimal Editor": "200,,false,, ",
    "Window/Presets/Sublime Mode": "300,,false,, ",
    "View/Menu Bar": "250,check,true,false,",
    "Edit/~300": "300,,,,",
    "Edit/Cut": "400,,false,false,Ctrl-X",
    "Edit/Copy": "500,,false,false,Ctrl-C",
    "Edit/Paste": "600,,false,false,Ctrl-V",
    "View/Editors": "100,,false,, ",
    "View/~200": "200,,,,",
    "View/Tab Buttons": "300,check,true,false,",
    "AWS Cloud9/~280": "280,,,,",
    "AWS Cloud9/Preferences": "300,,false,false,Ctrl-,",
    "Tools/~100000": "100000,,,,",
    "Tools/Developer": "100100,,false,, ",
    "Tools/Developer/Start in Debug Mode": "900,,false,, ",
    "Window/Environment": "100,check,true,,Ctrl-I",
    "File/~600": "600,,,,",
    "File/Save": "700,,false,false,Ctrl-S",
    "File/Save As...": "800,,false,false,Ctrl-Shift-S",
    "File/Save All": "900,,false,false,",
    "File/Revert to Saved": "1000,,false,false,Ctrl-Shift-Q",
    "File/Revert All to Saved": "1100,,false,false,Alt-Shift-Q",
    "View/Editors/Image Viewer": "40000,radio,false,true, ",
    "View/Editors/Image Editor": "40000,radio,false,true, ",
    "File/New File": "100,,false,false,Alt-N",
    "File/New From Template": "200,,false,false, ",
    "File/New From Template/Text File": "200,,false,false, ",
    "File/New From Template/JavaScript File": "200,,false,false, ",
    "File/New From Template/HTML File": "200,,false,false, ",
    "File/New From Template/XML File": "200,,false,false, ",
    "File/New From Template/Python File": "200,,false,false, ",
    "File/New From Template/PHP File": "200,,false,false, ",
    "File/New From Template/C File": "200,,false,false, ",
    "File/New From Template/C++ File": "200,,false,false, ",
    "File/New From Template/Go File": "200,,false,false, ",
    "File/New From Template/Markdown": "200,,false,false, ",
    "File/New From Template/Node.js Web Server": "200,,false,false, ",
    "File/New From Template/Java Console Application": "200,,false,false, ",
    "File/Open...": "400,,false,false,Ctrl-E|Ctrl-O",
    "Edit/Undo": "100,,false,true,Ctrl-Z",
    "Edit/Redo": "200,,false,true,Ctrl-Shift-Z|Ctrl-Y",
    "Help": "1000,,,,",
    "Help/Key Bindings Editor": "250,,false,,",
    "View/Editors/Ace": "40000,radio,false,true, ",
    "Tools/Toggle Macro Recording": "20100,,false,false,Alt-Shift-R",
    "Tools/Play Macro": "20200,,false,false,Alt-R",
    "Edit/~700": "700,,,,",
    "Edit/Selection": "800,,false,, ",
    "Edit/Line": "900,,false,, ",
    "Edit/Text": "1000,,false,, ",
    "Edit/Comment": "1100,,false,, ",
    "Edit/Code Folding": "1200,,false,, ",
    "Edit/Line/Indent": "100,,false,false,Tab",
    "Edit/Line/Outdent": "200,,false,false,Shift-Tab",
    "Edit/Line/Move Line Up": "300,,false,false,Alt-Up",
    "Edit/Line/Move Line Down": "400,,false,false,Alt-Down",
    "Edit/Line/~500": "500,,,false,",
    "Edit/Line/Copy Lines Up": "600,,false,false,Alt-Shift-Up",
    "Edit/Line/Copy Lines Down": "700,,false,false,Alt-Shift-Down",
    "Edit/Line/~800": "800,,,false,",
    "Edit/Line/Remove Line": "900,,false,false,Ctrl-D",
    "Edit/Line/Remove to Line End": "1000,,false,false,Alt-Delete",
    "Edit/Line/Remove to Line Start": "1100,,false,false,Alt-Backspace",
    "Edit/Line/~1200": "1200,,,false,",
    "Edit/Line/Split Line": "1300,,false,false,",
    "Edit/Comment/Toggle Comment": "100,,false,false,Ctrl-/",
    "Edit/Text/Remove Word Right": "100,,false,false,Ctrl-Delete",
    "Edit/Text/Remove Word Left": "200,,false,false,Ctrl-Backspace",
    "Edit/Text/~300": "300,,,false,",
    "Edit/Text/Align": "400,,false,false,Ctrl-Alt-A",
    "Edit/Text/Transpose Letters": "500,,false,false,Alt-Shift-X",
    "Edit/Text/~600": "600,,,false,",
    "Edit/Text/To Upper Case": "700,,false,false,Ctrl-U",
    "Edit/Text/To Lower Case": "800,,false,false,Ctrl-Shift-U",
    "Edit/Code Folding/Toggle Fold": "100,,false,false,F2",
    "Edit/Code Folding/Unfold": "200,,false,false,Alt-Shift-L|Ctrl-Shift-F1",
    "Edit/Code Folding/~300": "300,,,false,",
    "Edit/Code Folding/Fold Other": "400,,false,false,Alt-0",
    "Edit/Code Folding/Fold All": "500,,false,false,",
    "Edit/Code Folding/Unfold All": "600,,false,false,Alt-Shift-0",
    "Edit/Selection/Select All": "100,,false,false,Ctrl-A",
    "Edit/Selection/Split Into Lines": "200,,false,false,Ctrl-Alt-L",
    "Edit/Selection/Single Selection": "300,,false,true,esc",
    "Edit/Selection/~400": "400,,,false,",
    "Edit/Selection/Multiple Selections": "500,,false,false, ",
    "Edit/Selection/~600": "600,,,false,",
    "Edit/Selection/Select Word Right": "700,,false,false,Ctrl-Shift-Right",
    "Edit/Selection/Select Word Left": "800,,false,false,Ctrl-Shift-Left",
    "Edit/Selection/~900": "900,,,false,",
    "Edit/Selection/Select to Line End": "1000,,false,false,Alt-Shift-Right",
    "Edit/Selection/Select to Line Start": "1100,,false,false,Alt-Shift-Left",
    "Edit/Selection/~1200": "1200,,,false,",
    "Edit/Selection/Select to Document End": "1300,,false,false,Ctrl-Shift-End",
    "Edit/Selection/Select to Document Start": "1400,,false,false,Ctrl-Shift-Home",
    "Edit/Selection/Multiple Selections/Add Cursor Up": "100,,false,false,Ctrl-Alt-Up",
    "Edit/Selection/Multiple Selections/Add Cursor Down": "200,,false,false,Ctrl-Alt-Down",
    "Edit/Selection/Multiple Selections/Move Active Cursor Up": "300,,false,false,Ctrl-Alt-Shift-Up",
    "Edit/Selection/Multiple Selections/Move Active Cursor Down": "400,,false,false,Ctrl-Alt-Shift-Down",
    "Edit/Selection/Multiple Selections/~500": "500,,,,",
    "Edit/Selection/Multiple Selections/Add Next Selection Match": "600,,false,false,Ctrl-Alt-Right",
    "Edit/Selection/Multiple Selections/Add Previous Selection Match": "700,,false,false,Ctrl-Alt-Left",
    "Edit/Selection/Multiple Selections/~800": "800,,,,",
    "Edit/Selection/Multiple Selections/Merge Selection Range": "900,,false,false,Ctrl-Alt-L",
    "View/~290000": "290000,,,,",
    "View/Font Size": "290001,,false,, ",
    "View/Font Size/Increase Font Size": "100,,false,false,Ctrl-+|Ctrl-=",
    "View/Font Size/Decrease Font Size": "200,,false,false,Ctrl--",
    "View/Gutter": "500,check,true,, ",
    "File/~1400": "1400,,,,",
    "File/Line Endings": "1500,,false,, ",
    "File/Line Endings/Windows (CRLF)": "200,radio,false,false, ",
    "File/Line Endings/Unix (LF)": "300,radio,false,false, ",
    "View/Syntax": "300000,,false,, ",
    "View/~400000": "400000,,,,",
    "View/Wrap Lines": "500000,check,false,false, ",
    "View/Wrap To Print Margin": "600000,check,false,false, ",
    "Go/~399": "399,,,,",
    "Go/Next Error": "499,,false,false,Alt-E",
    "Go/Previous Error": "599,,false,false,Alt-Shift-E",
    "Go/~799": "799,,,,",
    "Go/Word Right": "899,,false,false,Ctrl-Right",
    "Go/Word Left": "999,,false,false,Ctrl-Left",
    "Go/~1099": "1099,,,,",
    "Go/Line End": "1199,,false,false,Alt-Right|End",
    "Go/Line Start": "1299,,false,false,Alt-Left|Home",
    "Go/~1399": "1399,,,,",
    "Go/Jump to Matching Brace": "1499,,false,false,Ctrl-P",
    "Go/~1599": "1599,,,,",
    "Go/Scroll to Selection": "1699,,false,false,",
    "View/Themes": "350000,,false,false, ",
    "Go/Go to Anything...": "100,,false,false,Ctrl-P",
    "Go/Go to Symbol...": "110,,false,false,Ctrl-Shift-O",
    "Go/Go to File...": "120,,false,false,Ctrl-E|Ctrl-O",
    "Go/Go to Command...": "130,,false,false,Ctrl-.",
    "Window/Go": "10,check,true,, ",
    "AWS Cloud9/~300": "300,,,,",
    "AWS Cloud9/Go To Your Dashboard": "310,,false,, ",
    "AWS Cloud9/~350": "350,,,,",
    "AWS Cloud9/Open Your Project Settings": "400,,false,, ",
    "AWS Cloud9/Open Your User Settings": "400,,false,, ",
    "AWS Cloud9/Open Your Keymap": "600,,false,, ",
    "AWS Cloud9/Open Your Init Script": "700,,false,, ",
    "AWS Cloud9/Open Your Stylesheet": "800,,false,, ",
    "AWS Cloud9/Restart AWS Cloud9": "2000080,,false,false,Ctrl-R",
    "Tools/Strip Trailing Space": "100,,false,false,",
    "Tools/~200": "200,,,,",
    "Go/Go to Line...": "200,,false,false,Ctrl-G",
    "View/Status Bar": "600,check,true,, ",
    "File/~100000": "100000,,,,",
    "File/Close File": "110000,,false,false,Alt-W",
    "File/Close All Files": "120000,,false,false,Alt-Shift-W",
    "Window/Tabs": "10100,,false,, ",
    "Window/Tabs/Close Pane": "100,,false,,Ctrl-W",
    "Window/Tabs/Close All Tabs In All Panes": "200,,false,,Alt-Shift-W",
    "Window/Tabs/Close All But Current Tab": "300,,false,,Ctrl-Alt-W",
    "Window/Tabs/~1000000": "1000000,,,,",
    "Window/Tabs/Split Pane in Two Rows": "1000100,,false,,",
    "Window/Tabs/Split Pane in Two Columns": "1000200,,false,,",
    "Window/Tabs/~1000300": "1000300,,,,",
    "Window/Tabs/~1000400": "1000400,,,,",
    "Window/~9000": "9000,,,,",
    "Window/Navigation": "9100,,false,, ",
    "Window/Navigation/Tab to the Right": "100,,false,true,Ctrl-]",
    "Window/Navigation/Tab to the Left": "200,,false,true,Ctrl-[",
    "Window/Navigation/Next Tab in History": "300,,false,true,Ctrl-Tab|Alt-`",
    "Window/Navigation/Previous Tab in History": "400,,false,true,Ctrl-Shift-Tab|Alt-Shift-`",
    "Window/Navigation/~500": "500,,,,",
    "Window/Navigation/Move Tab to Right": "600,,false,false,Ctrl-Meta-Right",
    "Window/Navigation/Move Tab to Left": "700,,false,false,Ctrl-Meta-Left",
    "Window/Navigation/Move Tab to Up": "800,,false,false,Ctrl-Meta-Up",
    "Window/Navigation/Move Tab to Down": "900,,false,false,Ctrl-Meta-Down",
    "Window/Navigation/~1000": "1000,,,,",
    "Window/Navigation/Go to Pane to Right": "1100,,false,false,Ctrl-Meta-Right",
    "Window/Navigation/Go to Pane to Left": "1200,,false,false,Ctrl-Meta-Left",
    "Window/Navigation/Go to Pane to Up": "1300,,false,false,Ctrl-Meta-Up",
    "Window/Navigation/Go to Pane to Down": "1400,,false,false,Ctrl-Meta-Down",
    "Window/Navigation/~1500": "1500,,,,",
    "Window/Navigation/Next Pane in History": "1600,,false,false,Ctrl-`",
    "Window/Navigation/Previous Pane in History": "1700,,false,false,Ctrl-Shift-`",
    "Window/~10000": "10000,,,,",
    "/context": ",,,,",
    "/context/tree": "0,,false,,",
    "/context/tree/Copy file path": "800,,false,false,",
    "/context/tree/~850": "850,,,false,",
    /*"/context/tabs": {
        "Reveal in File Tree": "100,,false,false,Ctrl-Shift-L",
        "~200": "200,,,,",
        "Copy file path": "230,,false,false,",
        "~260": "260,,,,",
        "Close Tab": "300,,false,false,Alt-W",
        "Close All Tabs": "450,,false,false,Ctrl-W",
        "Close Other Tabs": "500,,false,false,Ctrl-Alt-W",
        "Close Tabs to the Left": "600,,false,true,",
        "Close Tabs to the Right": "700,,false,true,",
        "~750": "750,,,,",
        "Split Pane in Two Rows": "800,,false,false,",
        "Split Pane in Two Columns": "900,,false,false,",
        "~1000": "1000,,,,",
        "Duplicate View": "1010,,false,false,",
        "Run This File": "150,,false,false, ",
    },*/
    "View/~800": "800,,,,",
    "View/Layout": "900,,false,, ",
    "View/Layout/Single": "100,,false,false,",
    "View/Layout/Vertical Split": "100,,false,false,",
    "View/Layout/Horizontal Split": "200,,false,false,",
    "View/Layout/Cross Split": "300,,false,false,",
    "View/Layout/Split 1:2": "400,,false,false,",
    "View/Layout/Split 2:1": "500,,false,false,",
    "Window/Saved Layouts": "10050,,false,, ",
    "Edit/~650": "650,,,,",
    "Edit/Keyboard Mode": "660,,false,, ",
    "Edit/Keyboard Mode/Default": "1100,radio,true,, ",
    "Edit/Keyboard Mode/Vim": "1200,radio,false,, ",
    "Edit/Keyboard Mode/Emacs": "1300,radio,false,, ",
    "Edit/Keyboard Mode/Sublime": "1400,radio,false,, ",
    "Find/~10000": "10000,,,,",
    "Find/Find in Files...": "20000,,false,false,Ctrl-Shift-F",
    "Find/Find...": "100,,false,false,Ctrl-F",
    "Find/Find Next": "200,,false,false,Ctrl-K",
    "Find/Find Previous": "300,,false,false,Ctrl-Shift-K",
    "Find/~400": "400,,,,",
    "Find/Replace...": "500,,false,false,Alt-Shift-F|Ctrl-H",
    "Find/Replace Next": "600,,false,false,",
    "Find/Replace Previous": "700,,false,false,",
    "Find/Replace All": "800,,false,false,",
    "Tools/~2000": "2000,,,,",
    "Tools/Show Autocomplete": "2100,,false,false,Ctrl-Space|Alt-Space",
    "Tools/~10000": "10000,,,,",
    "Tools/Rename variable": "2100,,false,false,Ctrl-Alt-R",
    "Go/Jump to Definition": "1450,,false,false,F3",
    "Go/Find References": "1450,,false,false,Shift-F3",
    "Window/Debugger": "100,check,true,,",
    "Run": "600,,,,",
    "Run/Run": "1100,,false,true,Alt-F5",
    "Run/Run Last": "1200,,false,true,F5",
    "Run/~1300": "1300,,,,",
    "Run/Run With": "1400,,false,, ",
    "Run/Run History": "1500,,false,true, ",
    "Run/Run Configurations": "1600,,false,, ",
    "Run/~2600": "2600,,,,",
    "Run/Show Debugger at Break": "2700,check,true,, ",
    "Run/Run Configurations/~1000": "1000,,,,",
    "Run/Run Configurations/New Run Configuration": "1100,,false,, ",
    "Run/Run Configurations/Manage...": "1200,,false,, ",
    "Run/Run With/~1000": "1000,,,,",
    "Run/Run With/New Runner": "1100,,false,, ",
    "Run/Run With/Edit Runner": "1200,,false,, ",
    "Window/New Terminal": "30,,false,false,Alt-T",
    "Window/Navigation/Switch Between Editor and Terminal": "1550,,false,false,Alt-S",
    "Run/~10100": "10100,,,,",
    "Run/Build": "10200,,false,false,Ctrl-B",
    "Run/Cancel Build": "10300,,false,true,Ctrl-Shift-C",
    "Run/Build System": "10400,,false,, ",
    "Run/Show Build Result": "10500,,false,, ",
    "Run/~10600": "10600,,,,",
    "Run/Automatically Build Supported Files": "10700,check,false,, ",
    "Run/Save All on Build": "10800,check,true,, ",
    "Run/Build System/Automatic": "100,radio,true,, ",
    "Run/Build System/~200": "200,,,,",
    "Run/Build System/~1200": "1200,,,,",
    "Run/Build System/New Build System": "1300,,false,, ",
    "Window/New Immediate Window": "31,,false,, ",
    "View/Editors/Preview": "40000,radio,false,true, ",
    "Tools/Preview": "1000,,false,, ",
    "Tools/Preview/Live Preview Files": "100,,false,true, ",
    "Tools/Preview/Preview Running Application": "200,,false,, ",
    "Tools/Preview/~2000": "2000,,,,",
    "Tools/Preview/~4000": "4000,,,,",
    "Tools/Preview/Configure Preview URL...": "4200,,false,, ",
    "Tools/Preview/Show Active Servers...": "4300,,false,, ",
    "File/~1200": "1200,,,,",
    "File/Upload Local Files...": "1300,,false,, ",
    "Window/Outline": "50,check,true,,Ctrl-Shift-E",
    "View/Open Files": "210,check,false,, ",
    "Tools/Process List": "1100,,false,false,Ctrl-Alt-P",
    "Window/Installer...": "38,,false,false,",
    "Edit/Code Formatting": "1400,,false,, ",
    "Edit/Code Formatting/Apply Code Formatting": "100,,true,,Ctrl-Shift-B",
    "Edit/Code Formatting/Open Language & Formatting Preferences...": "200,,true,,",
    "File/Download Project": "1300,,false,, ",
    "File/Open Recent": "500,,false,, ",
    "File/Open Recent/~1000000": "1000000,,,,",
    "File/Open Recent/Clear Menu": "2000000,,false,true, ",
    "/user_info": "600,,,,",
    "/user_info/Go To Dashboard": "600,,false,, ",
    "Window/~40": "40,,,,",
    "/context/ace": "0,,false,,",
    "/context/ace-gutter": "0,,false,,",
    "/context/ace-gutter/Gutter Options": "1100,,false,, ",
    "/context/ace-gutter/Gutter Options/Show Line Numbers": "100,,false,,",
    "/context/ace-gutter/Gutter Options/Show Fold Widgets": "200,,false,,",
    "/context/terminal": ",,false,,",
    "/context/terminal/New Terminal Tab": "200,,false,,",
    "/context/terminal/~300": "300,,,,",
    "/context/terminal/Copy": "400,,false,,",
    "/context/terminal/Paste": "500,,false,,",
    "/context/terminal/Select All": "600,,false,,",
    "/context/terminal/Clear Buffer": "700,,false,,",
    "/context/terminal/~800": "800,,,,",
    "/context/terminal/Hint: Use Alt To Toggle Mouse Mode": "900,,false,,",
    "View/Syntax/Auto-Select": "100,radio,false,, ",
    "View/Syntax/Plain Text": "200,radio,true,, ",
    "View/Syntax/~300": "300,,,,",
    "View/Syntax/C and C++": "400,radio,false,, ",
    "View/Syntax/C#": "500,radio,false,, ",
    "View/Syntax/Clojure": "600,radio,false,, ",
    "View/Syntax/CoffeeScript": "700,radio,false,, ",
    "View/Syntax/CSS": "800,radio,false,, ",
    "View/Syntax/Dart": "900,radio,false,, ",
    "View/Syntax/Go": "1000,radio,false,, ",
    "View/Syntax/HTML": "1100,radio,false,, ",
    "View/Syntax/Jade": "1200,radio,false,, ",
    "View/Syntax/Java": "1300,radio,false,, ",
    "View/Syntax/JavaScript": "1400,radio,false,, ",
    "View/Syntax/JSON": "1500,radio,false,, ",
    "View/Syntax/LESS": "1600,radio,false,, ",
    "View/Syntax/Lua": "1700,radio,false,, ",
    "View/Syntax/Perl": "1800,radio,false,, ",
    "View/Syntax/PHP": "1900,radio,false,, ",
    "View/Syntax/Python": "2000,radio,false,, ",
    "View/Syntax/Ruby": "2100,radio,false,, ",
    "View/Syntax/Scala": "2200,radio,false,, ",
    "View/Syntax/SCSS": "2300,radio,false,, ",
    "View/Syntax/SH": "2400,radio,false,, ",
    "View/Syntax/SQL": "2500,radio,false,, ",
    "View/Syntax/Stylus": "2600,radio,false,, ",
    "View/Syntax/Text": "2700,radio,true,, ",
    "View/Syntax/Typescript": "2800,radio,false,, ",
    "View/Syntax/XML": "2900,radio,false,, ",
    "View/Syntax/XQuery": "3000,radio,false,, ",
    "View/Syntax/YAML": "3100,radio,false,, ",
    "View/Syntax/~3200": "3200,,,,",
    "View/Syntax/ABAP": "3300,radio,false,, ",
    "View/Syntax/ABC": "3400,radio,false,, ",
    "View/Syntax/ActionScript": "3500,radio,false,, ",
    "View/Syntax/ADA": "3600,radio,false,, ",
    "View/Syntax/Apache Conf": "3700,radio,false,, ",
    "View/Syntax/Apex": "3800,radio,false,, ",
    "View/Syntax/AQL": "3900,radio,false,, ",
    "View/Syntax/AsciiDoc": "4000,radio,false,, ",
    "View/Syntax/ASL": "4100,radio,false,, ",
    "View/Syntax/Assembly x86": "4200,radio,false,, ",
    "View/Syntax/AutoHotkey ": ",,false,,",
    "View/Syntax/AutoHotkey / AutoIt": "4300,,false,,",
    "View/Syntax/BatchFile": "4400,radio,false,, ",
    "View/Syntax/C9Search": "4500,radio,false,, ",
    "View/Syntax/Cirru": "4600,radio,false,, ",
    "View/Syntax/Cobol": "4700,radio,false,, ",
    "View/Syntax/ColdFusion": "4800,radio,false,, ",
    "View/Syntax/Crystal": "4900,radio,false,, ",
    "View/Syntax/Csound": "5000,radio,false,, ",
    "View/Syntax/Csound Document": "5100,radio,false,, ",
    "View/Syntax/Csound Score": "5200,radio,false,, ",
    "View/Syntax/Curly": "5300,radio,false,, ",
    "View/Syntax/D": "5400,radio,false,, ",
    "View/Syntax/Diff": "5500,radio,false,, ",
    "View/Syntax/Django": "5600,radio,false,, ",
    "View/Syntax/Dockerfile": "5700,radio,false,, ",
    "View/Syntax/Dot": "5800,radio,false,, ",
    "View/Syntax/Drools": "5900,radio,false,, ",
    "View/Syntax/Edifact": "6000,radio,false,, ",
    "View/Syntax/Eiffel": "6100,radio,false,, ",
    "View/Syntax/EJS": "6200,radio,false,, ",
    "View/Syntax/Elixir": "6300,radio,false,, ",
    "View/Syntax/Elm": "6400,radio,false,, ",
    "View/Syntax/Erlang": "6500,radio,false,, ",
    "View/Syntax/Forth": "6600,radio,false,, ",
    "View/Syntax/Fortran": "6700,radio,false,, ",
    "View/Syntax/FreeMarker": "6800,radio,false,, ",
    "View/Syntax/FSharp": "6900,radio,false,, ",
    "View/Syntax/FSL": "7000,radio,false,, ",
    "View/Syntax/Gcode": "7100,radio,false,, ",
    "View/Syntax/Gherkin": "7200,radio,false,, ",
    "View/Syntax/Gitignore": "7300,radio,false,, ",
    "View/Syntax/Glsl": "7400,radio,false,, ",
    "View/Syntax/Gobstones": "7500,radio,false,, ",
    "View/Syntax/GraphQLSchema": "7600,radio,false,, ",
    "View/Syntax/Groovy": "7700,radio,false,, ",
    "View/Syntax/HAML": "7800,radio,false,, ",
    "View/Syntax/Handlebars": "7900,radio,false,, ",
    "View/Syntax/Haskell": "8000,radio,false,, ",
    "View/Syntax/Haskell Cabal": "8100,radio,false,, ",
    "View/Syntax/haXe": "8200,radio,false,, ",
    "View/Syntax/Hjson": "8300,radio,false,, ",
    "View/Syntax/HTML (Elixir)": "8400,radio,false,, ",
    "View/Syntax/HTML (Ruby)": "8500,radio,false,, ",
    "View/Syntax/INI": "8600,radio,false,, ",
    "View/Syntax/Io": "8700,radio,false,, ",
    "View/Syntax/Jack": "8800,radio,false,, ",
    "View/Syntax/JSONiq": "8900,radio,false,, ",
    "View/Syntax/JSP": "9000,radio,false,, ",
    "View/Syntax/JSSM": "9100,radio,false,, ",
    "View/Syntax/JSX": "9200,radio,false,, ",
    "View/Syntax/Julia": "9300,radio,false,, ",
    "View/Syntax/Kotlin": "9400,radio,false,, ",
    "View/Syntax/LaTeX": "9500,radio,false,, ",
    "View/Syntax/Liquid": "9600,radio,false,, ",
    "View/Syntax/Lisp": "9700,radio,false,, ",
    "View/Syntax/LiveScript": "9800,radio,false,, ",
    "View/Syntax/LogiQL": "9900,radio,false,, ",
    "View/Syntax/LSL": "10000,radio,false,, ",
    "View/Syntax/LuaPage": "10100,radio,false,, ",
    "View/Syntax/Lucene": "10200,radio,false,, ",
    "View/Syntax/Makefile": "10300,radio,false,, ",
    "View/Syntax/Markdown": "10400,radio,false,, ",
    "View/Syntax/Mask": "10500,radio,false,, ",
    "View/Syntax/MATLAB": "10600,radio,false,, ",
    "View/Syntax/Maze": "10700,radio,false,, ",
    "View/Syntax/MEL": "10800,radio,false,, ",
    "View/Syntax/MIXAL": "10900,radio,false,, ",
    "View/Syntax/MUSHCode": "11000,radio,false,, ",
    "View/Syntax/MySQL": "11100,radio,false,, ",
    "View/Syntax/Nginx": "11200,radio,false,, ",
    "View/Syntax/Nim": "11300,radio,false,, ",
    "View/Syntax/Nix": "11400,radio,false,, ",
    "View/Syntax/NSIS": "11500,radio,false,, ",
    "View/Syntax/Objective-C": "11600,radio,false,, ",
    "View/Syntax/OCaml": "11700,radio,false,, ",
    "View/Syntax/Pascal": "11800,radio,false,, ",
    "View/Syntax/Perl 6": "11900,radio,false,, ",
    "View/Syntax/pgSQL": "12000,radio,false,, ",
    "View/Syntax/PHP (Blade Template)": "12100,radio,false,, ",
    "View/Syntax/Pig": "12200,radio,false,, ",
    "View/Syntax/Powershell": "12300,radio,false,, ",
    "View/Syntax/Praat": "12400,radio,false,, ",
    "View/Syntax/Prolog": "12500,radio,false,, ",
    "View/Syntax/Properties": "12600,radio,false,, ",
    "View/Syntax/Protobuf": "12700,radio,false,, ",
    "View/Syntax/Puppet": "12800,radio,false,, ",
    "View/Syntax/R": "12900,radio,false,, ",
    "View/Syntax/Razor": "13000,radio,false,, ",
    "View/Syntax/RDoc": "13100,radio,false,, ",
    "View/Syntax/Red": "13200,radio,false,, ",
    "View/Syntax/RHTML": "13300,radio,false,, ",
    "View/Syntax/RST": "13400,radio,false,, ",
    "View/Syntax/Rust": "13500,radio,false,, ",
    "View/Syntax/SASS": "13600,radio,false,, ",
    "View/Syntax/SCAD": "13700,radio,false,, ",
    "View/Syntax/Scheme": "13800,radio,false,, ",
    "View/Syntax/SJS": "13900,radio,false,, ",
    "View/Syntax/Slim": "14000,radio,false,, ",
    "View/Syntax/Smarty": "14100,radio,false,, ",
    "View/Syntax/Soy Template": "14200,radio,false,, ",
    "View/Syntax/Space": "14300,radio,false,, ",
    "View/Syntax/SQLServer": "14400,radio,false,, ",
    "View/Syntax/SVG": "14500,radio,false,, ",
    "View/Syntax/Swift": "14600,radio,false,, ",
    "View/Syntax/Tcl": "14700,radio,false,, ",
    "View/Syntax/Terraform": "14800,radio,false,, ",
    "View/Syntax/Tex": "14900,radio,false,, ",
    "View/Syntax/Textile": "15000,radio,false,, ",
    "View/Syntax/Toml": "15100,radio,false,, ",
    "View/Syntax/TSX": "15200,radio,false,, ",
    "View/Syntax/Twig": "15300,radio,false,, ",
    "View/Syntax/Vala": "15400,radio,false,, ",
    "View/Syntax/VBScript": "15500,radio,false,, ",
    "View/Syntax/Velocity": "15600,radio,false,, ",
    "View/Syntax/Verilog": "15700,radio,false,, ",
    "View/Syntax/VHDL": "15800,radio,false,, ",
    "View/Syntax/Visualforce": "15900,radio,false,, ",
    "View/Syntax/Wollok": "16000,radio,false,, ",
    "View/Syntax/Zeek": "16100,radio,false,, ",
    "View/Themes/UI Themes": "0,,false,false, ",
    "View/Themes/~200": "200,,,false,",
    "View/Themes/UI Themes/Classic Dark": "0,radio,false,, ",
    "View/Themes/UI Themes/Classic Dark Gray": "0,radio,false,, ",
    "View/Themes/UI Themes/Flat Light": "0,radio,false,, ",
    "View/Themes/Ambiance": "200,radio,false,false, ",
    "View/Themes/Chrome": "201,radio,false,false, ",
    "View/Themes/Cloud9": "202,,false,false, ",
    "View/Themes/Cloud9/Cloud9 Day": ",radio,false,, ",
    "View/Themes/Cloud9/Cloud9 Night": ",radio,false,, ",
    "View/Themes/Cloud9/Cloud9 Night Low-Color": ",radio,false,, ",
    "View/Themes/Clouds": "203,,false,false, ",
    "View/Themes/Clouds/Clouds": ",radio,false,, ",
    "View/Themes/Clouds/Clouds Midnight": ",radio,false,, ",
    "View/Themes/Cobalt": "204,radio,false,false, ",
    "View/Themes/Crimson Editor": "205,radio,false,false, ",
    "View/Themes/Dawn": "206,radio,false,false, ",
    "View/Themes/Dreamweaver": "207,radio,false,false, ",
    "View/Themes/Eclipse": "208,radio,false,false, ",
    "View/Themes/GitHub": "209,radio,false,false, ",
    "View/Themes/Idle Fingers": "210,radio,false,false, ",
    "View/Themes/Kr Theme": "211,radio,false,false, ",
    "View/Themes/Merbivore": "212,,false,false, ",
    "View/Themes/Merbivore/Merbivore": ",radio,false,, ",
    "View/Themes/Merbivore/Merbivore Soft": ",radio,false,, ",
    "View/Themes/Mono Industrial": "213,radio,false,false, ",
    "View/Themes/Monokai": "214,radio,false,false, ",
    "View/Themes/Pastel On Dark": "215,radio,false,false, ",
    "View/Themes/Solarized": "216,,false,false, ",
    "View/Themes/Solarized/Solarized Dark": ",radio,false,, ",
    "View/Themes/Solarized/Solarized Light": ",radio,false,, ",
    "View/Themes/TextMate": "217,radio,false,false, ",
    "View/Themes/Tomorrow": "218,,false,false, ",
    "View/Themes/Tomorrow/Tomorrow": ",radio,false,, ",
    "View/Themes/Tomorrow/Tomorrow Night": ",radio,false,, ",
    "View/Themes/Tomorrow/Tomorrow Night Blue": ",radio,false,, ",
    "View/Themes/Tomorrow/Tomorrow Night Bright": ",radio,false,, ",
    "View/Themes/Tomorrow/Tomorrow Night Eighties": ",radio,false,, ",
    "View/Themes/Twilight": "219,radio,false,false, ",
    "View/Themes/Vibrant Ink": "220,radio,false,false, ",
    "View/Themes/Xcode": "221,radio,false,false, ",
    "View/Themes/Jett": "222,radio,false,false, ",
    "Window/Saved Layouts/Save...": "100,,false,,",
    "Window/Saved Layouts/Save And Close All...": "200,,false,,",
    "Window/Saved Layouts/~300": "300,,,,",
    "Window/Saved Layouts/Show Saved Layouts in File Tree": "400,,false,, ",
    "Window/Saved Layouts/~500": "500,,,,"
};

export function addExampleMenuItems(menuManager, root, menuDefinitions = menuDefs) {
    let commands: Ace.Command[] = [];
    Object.keys(menuDefinitions).forEach(function (x) {
        let item = menuDefinitions[x];
        let exec;
        if (typeof item == "object") {
            if (item.properties != undefined) {
                exec = item.exec;
                item = item.properties;
            } else {
                return addExampleMenuItems(menuManager, x, item);
            }
        }
        let parts: string[] = /(\d*),([^,]*),([^,]*),([^,]*),(.*)/.exec(item) ?? [];
        let path = root ? root + "/" + x : x;
        let hotKey = (parts[5] || "").trim();
        if (exec && hotKey) {
            commands.push({
                bindKey: {
                    win: hotKey,
                    mac: hotKey
                },
                exec: exec
            })
        }

        menuManager.addByPath(path, {
            className: path == "AWS Cloud9" ? "c9btn" : undefined,
            type: parts[2],
            checked: parts[3] == "true",
            disabled: parts[4] == "true",
            position: parseInt(parts[1]),
            hotKey: hotKey,
            exec: exec
        });
    });
    CommandManager.registerCommands(commands);
}
